import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';
import { shouldRefreshInboxBadge, INBOX_COUNT_EVENT } from './performanceInboxBadge';

// P2 Faz 1 — sol menü "Performans Gelen Kutum" rozeti (spec §Bileşen 3). Sayı GET
// /v1/performance/inbox/count'tan gelir: liste ucuyla AYNI toplamayı yapar ama
// sonucu kullanıcı başına 60 sn önbellekler (rozet her sayfa yüklemesinde
// çağrılır, liste ~5 servisin tenant-geneli org taramasını tetikler).
//
// Önbelleğin doğurduğu gecikmeyi gelen kutusu sayfası kapatır: sayfa her
// çekişinde kendi kesin sayısını INBOX_COUNT_EVENT ile yayınlar, rozet onu
// ANINDA benimser (iş tamamlandığında rozet TTL beklemez).
//
// `enabled` false iken (PM aboneliği yok / preboarding kilidi) HİÇ istek
// atılmaz — menü öğesi de zaten görünmez. İstek skipErrorToast ile sessizdir:
// arka plan okuması kullanıcıya sahte hata toast'ı gösteremez.
export default function usePerformanceInboxBadge(enabled) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  const prevPathRef = useRef(null);
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    const prev = prevPathRef.current;
    prevPathRef.current = pathname;
    if (shouldRefreshInboxBadge(prev, pathname)) setRefreshTick((p) => p + 1);
  }, [pathname]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    let cancelled = false;
    api.get('/v1/performance/inbox/count', { skipErrorToast: true })
      .then((res) => {
        if (cancelled) return;
        setCount(res.data?.status ? (res.data.data?.count || 0) : 0);
      })
      .catch(() => { if (!cancelled) setCount(0); });
    return () => { cancelled = true; };
  }, [enabled, refreshTick]);

  // Sayfanın yayınladığı kesin sayı önbelleği ezer.
  useEffect(() => {
    if (!enabled) return undefined;
    const onExactCount = (e) => {
      const exact = e?.detail?.count;
      if (typeof exact === 'number') setCount(exact);
    };
    window.addEventListener(INBOX_COUNT_EVENT, onExactCount);
    return () => window.removeEventListener(INBOX_COUNT_EVENT, onExactCount);
  }, [enabled]);

  return count;
}
